module.exports = "/images/testimonial-user.png?52ce940dffbc872c2decf85fbe2ac2e9";